// extracted by mini-css-extract-plugin
module.exports = {"DownloadIcon":"DownloadExel_DownloadIcon__14NOY","DownloadMsg":"DownloadExel_DownloadMsg__2VIZN"};